<template>
  <div class="defect-issues-main">
    <div class="header">
      <div class="title">{{ contentTitle }}</div>
      <el-button style="margin-right: 24px;" type="primary" size="small" @click="confirm">
        {{ $l('btn_confirm_fill_in') || '确认填报' }}
      </el-button>
    </div>

    <div class="content">
      <el-checkbox-group v-model="selectedIssues">
        <div
          v-for="group in groupedData"
          :key="group.defectIssuesGroup"
          class="issue-group"
        >
          <div class="group-title">{{ group.defectIssuesGroup }}</div>
          <div class="group-items">
            <el-checkbox
              v-for="item in group.items"
              :key="item.defectIssuesCode"
              :label="item.defectIssuesCode"
              :value="item.defectIssuesCode"
            >
              {{ item.defectIssuesTitle }}
            </el-checkbox>
          </div>
          <div v-if="getOtherProblemCode(group.items)" class="other-problem-desc">
            <div class="other-problem-title">其他问题描述</div>
            <el-input
              v-model="otherProblemDesc"
              type="textarea"
              :rows="4"
              placeholder="请输入其他问题描述"
              maxlength="500"
              show-word-limit
            />
          </div>
        </div>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'DefectIssuesMain',
  props: {
    contentTitle: {
      type: String,
      default: ''
    },
    issueType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedIssues: [],
      issuesList: [],
      otherProblemDesc: ''
    }
  },
  computed: {
    groupedData() {
      if (lodash.isEmpty(this.issuesList)) return []
      
      const grouped = lodash.groupBy(this.issuesList, 'defectIssuesGroup')
      
      return Object.entries(grouped).map(([defectIssuesGroup, items]) => ({
        defectIssuesGroup,
        items
      }))
    }
  },
  mounted() {
    this.loadIssuesList()
  },
  methods: {
    async loadIssuesList() {
      try {
        const res = await this.$api.inspectionDefectIssuesListApi({
          issueType: this.issueType
        })
        
        if (res.status === 200 && res.body?.data) {
          this.issuesList = res.body.data
          this.otherProblemDesc = ''
        }
      } catch (error) {
        this.$message.error(error.message || '系统异常')
      }
    },
    shouldShowOtherProblemDesc(item = {}) {
      return (
        this.issueType === 'B' &&
        (item.defectIssuesTitle || '').trim() === '其他' &&
        this.selectedIssues.includes(item.defectIssuesCode)
      )
    },
    getOtherProblemCode(items = []) {
      const otherOption = items.find((item) => this.shouldShowOtherProblemDesc(item))
      return otherOption?.defectIssuesCode || ''
    },
    confirm() {
      if (lodash.isEmpty(this.selectedIssues)) {
        this.$message.warning('请选择原因')
        return
      }
      
      const filtered = this.issuesList.filter(item =>
        this.selectedIssues.includes(item.defectIssuesCode)
      )
      
      this.$emit(
        'confirm',
        filtered.map((item) => ({
          ...item,
          otherProblemDesc: this.shouldShowOtherProblemDesc(item)
            ? this.otherProblemDesc.trim()
            : ''
        }))
      )
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.defect-issues-main {
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    margin-bottom: 16px;
    
    .title {
      margin-left: 24px;
      font-size: 16px;
      font-weight: 600;
      color: #071437;
    }
  }
  
  .content {
    .issue-group {
      margin-bottom: 24px;
      margin-left: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      
      .group-title {
        font-size: 14px;
        font-weight: 600;
        color: #101010;
        margin-bottom: 12px;
      }
      
      .group-items {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 20px;
        
        :deep(.el-checkbox) {
          margin-right: 0;
          
          .el-checkbox__label {
            font-size: 13px;
            color: #333;
          }
        }
      }

      .other-problem-desc {
        margin-top: 12px;

        .other-problem-title {
          margin-bottom: 8px;
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>
